import { brand, semantic, surface, text } from '@vuelto/tokens';

/** Adapter RN: nombres legacy de la app sobre @vuelto/tokens. */
export const colors = {
  background: surface.bg,
  surface: surface.surface,
  surfaceSecondary: surface.surfaceSecondary,
  border: surface.border,
  borderSoft: surface.borderSoft,
  /** Fondo de controles secundarios (botones/chips) sobre tarjetas `surface`; más claro que surface para legibilidad. */
  controlSurface: surface.controlSurface,
  /** Borde de controles secundarios; más visible que `border`. */
  controlBorder: surface.borderControl,
  accent: brand[500],
  accentMuted: brand[600],
  accentStrong: brand[700],
  accentSoft: semantic.accentSoft,
  success: semantic.success,
  danger: semantic.danger,
  warning: semantic.warning,
  info: semantic.info,
  textPrimary: text.primary,
  textSecondary: text.secondary,
  textMuted: text.muted,
  inputBackground: surface.inputBackground,
  inputBorder: surface.borderControl,
  inputPlaceholder: text.muted,
  overlay: surface.overlay,
};
